/**
 * @generated SignedSource<<4d4b745fc6a89f2a7096f6d8f90a82ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelColorMappingInput = {
  colorID: number;
  merchantCode: string;
  salesChannelID: string;
};
export type connectModelDialogSetModelColorMappingMutation$variables = {
  modelColorMappings: ReadonlyArray<ModelColorMappingInput>;
  modelID: string;
};
export type connectModelDialogSetModelColorMappingMutation$data = {
  readonly setModelColorMapping: ReadonlyArray<{
    readonly colorID: number;
    readonly merchantCode: string;
  }> | null;
};
export type connectModelDialogSetModelColorMappingMutation = {
  response: connectModelDialogSetModelColorMappingMutation$data;
  variables: connectModelDialogSetModelColorMappingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelColorMappings"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelColorMappings",
        "variableName": "modelColorMappings"
      },
      {
        "kind": "Variable",
        "name": "modelID",
        "variableName": "modelID"
      }
    ],
    "concreteType": "ModelColorMapping",
    "kind": "LinkedField",
    "name": "setModelColorMapping",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "colorID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "merchantCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "connectModelDialogSetModelColorMappingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "connectModelDialogSetModelColorMappingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2fe3a4f9865a48961a68cb8acd196727",
    "id": null,
    "metadata": {},
    "name": "connectModelDialogSetModelColorMappingMutation",
    "operationKind": "mutation",
    "text": "mutation connectModelDialogSetModelColorMappingMutation(\n  $modelID: ID!\n  $modelColorMappings: [ModelColorMappingInput!]!\n) {\n  setModelColorMapping(modelID: $modelID, modelColorMappings: $modelColorMappings) {\n    colorID\n    merchantCode\n  }\n}\n"
  }
};
})();

(node as any).hash = "f49f9e122178c380bee8767545efa9f3";

export default node;
